import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initialiseTheme } from './lib/theme';
import { initialiseDisplayScale } from './lib/displayScale';





















// Official GOV.UK Frontend plus the sole Sousa Murray caseworking design stylesheet.
import 'govuk-frontend/dist/govuk/govuk-frontend.min.css';
import './sousa-murray-casework.css';



initialiseTheme();
initialiseDisplayScale();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
